<div class="dialog" fxLayout="column">
  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'通知管理：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'通知管理：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addNotice()" [disabled]="!noticeFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="noticeFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'通知種別' | translate}}</mat-label>
              <mat-select placeholder="{{'通知種別' | translate}}" id="noticeType" formControlName="noticeType">
                <mat-option *ngFor="let noticeType of noticeTypes" [value]="noticeType.type">
                  {{ noticeType.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <mat-form-field>
            <mat-label floatLabel="always">{{'タイトル' | translate}}</mat-label>
            <input matInput placeholder="{{'タイトル' | translate}}" id="noticeTitle" formControlName="noticeTitle" value="{{ notice!.notice_title }}">
            <mat-error *ngIf="noticeTitleControl.invalid">{{ getErrorMessageToNoticeTitle() }}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="noticeDetail" formControlName="noticeDetail" rows="3"
              value="{{ notice!.notice_detail }}">
            </textarea>
            <mat-error *ngIf="noticeDetailControl.invalid">{{ getErrorMessageToNoticeDetail() }}</mat-error>
          </mat-form-field>

        </div>

        <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <div class="project-ids">
            <div class="project-ids-title" fxLayout="row" fxLayoutAlign="space-between end">
              <span>{{'プロジェクトリスト（' | translate}} {{ !!notice!.project_ids ? notice!.project_ids.length:0 }} {{'件）' | translate}}</span>
              <button mat-stroked-button (click)="openSelectProjectDialog()">
                <mat-icon>add</mat-icon>
                <span>{{'プロジェクト追加' | translate}}</span>
              </button>
            </div>

            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>{{'名称' | translate}}</th>
                  <th>{{'削除' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let project of projects">
                  <td>{{ project.project_id }}</td>
                  <td>{{ project.project_name }}</td>
                  <td>
                    <button mat-stroked-button color="warn" (click)="deleteProject(project.project_id)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </form>
  </div>

</div>